module.exports = "<p>To download the variant data click on the ‘Download’ button located above the search bar within the Variants Table page. When you click on it the data that is downloaded is a comma delimited .csv file containing the set of variant details for the variants that matched the search and/or filtering criteria. The first row in the file represent the column labels.</p>";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/downloading-variant-data.md
// module id = 1267
// module chunks = 0